<template>
    <div>
        <div class="mb-4 grid grid-cols-4 gap-3" v-if="!applied">
            <div class="col-span-3">
                <TextInput label="Got a Promo Code?" v-model="code"></TextInput>
                <span class="text-red-500">{{ error }}</span>
            </div>
            <div class="col-span-1">
                <button
                    :disabled="applied"
                    @click="applyPromotion"
                    type="button"
                    class="block transition ease-in-out duration-150 disabled:cursor-not-allowed bg-white py-2 lg:px-5 lg:py-2 mt-5 text-brand-blue rounded-lg w-full bg-ap-fs-primary border border-brand-blue disabled:text-slate-50 disabled:bg-slate-500"
                >
                    Apply
                </button>
            </div>
        </div>
        <div class="mb-4 border border-brand-orange" v-else>
            <p class="text-center">{{ applied }} promotion applied</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import TextInput from '../TextInput.vue';

export default {
    data() {
        return {
            code: null,
            applied: false,
            error: null,
        };
    },
    methods: {
        applyPromotion() {
            axios.post('/promotions', {
                code: this.code,
            }).then((response) => {
                this.$emit('priceChange', response.data);
                this.error = null;
                this.applied = this.code;
            }).catch((error) => {
                this.error = error.response.data;
            });
        },
    },
    components: {
        TextInput,
    },
};
</script>
